<template lang="pug">
  .aside__subblock
    p.aside__subblock-desc(v-if="idx === ''")
      | Заполните данные, чтобы создать новую папку.
    .aside__list
      .aside__item.-full-
        Input(
          title="Название папки"
          placeholder="Папка скорость"
          :error="$v.name.$dirty && !$v.name.required"
          v-model.trim="name"
          @input="compare"
        )
          span.form-item__error(v-if="$v.name.$dirty && !$v.required")
            | Обязательное поле

      .aside__item.-full-
        Input(
          title="Описание"
          placeholder="Описание папки"
          v-model.trim="description"
          @input="compare"
        )

      .aside__item.-full-
        DropAsideImage(
          v-model="img"
          @input="compare"
        )

      .aside__item.-full-
        DropAsideImage(
          v-model="coverImg"
          dragText="Загрузить обложку для приложения (290х190 или 420х190)"
          @input="compare"
        )

</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import { required } from 'vuelidate/lib/validators';

export default {
  data: () => ({
    description: '',
    name: '',
    img: '',
    coverImg: '',
    group: {}
  }),
  computed: {
    ...mapState('coursesFolder', {
      idx: s => s.aside.data.idx,
      folder: s => s.aside.data.folder,
      canSave: s => s.aside.meta.canSave
    })
  },
  beforeMount() {
    this.setData();
  },
  methods: {
    setData() {
      if (this.idx !== '') {
        Object.entries(_.cloneDeep(this.folder)).forEach(el => {
          this[el[0]] = el[1];
        });
        this.$store.dispatch('coursesFolder/setAsideMeta', {
          path: 'canSave',
          value: false
        });
      }
    },
    compare() {
      const object = {
        name: this.name,
        img: null,
        coverImg: null
      };

      if (this.description) {
        object.description = this.description;
      }
      if (this.img && this.img.id) {
        object.img = this.img.id;
      }

      if (this.coverImg && this.coverImg.id) {
        object.coverImg = this.coverImg.id;
      }

      if (this.$v.$invalid) {
        this.$v.$touch();

        if (this.canSave) {
          this.$store.dispatch('coursesFolder/setAsideMeta', {
            path: 'canSave',
            value: false
          });
        }
        return;
      }

      if (this.name.length >= 1) {
        this.$store.dispatch('coursesFolder/setAsideMeta', {
          path: 'canSave',
          value: true
        });

        this.$store.dispatch('coursesFolder/setAsideData', {
          path: 'folder',
          value: object
        });
      }
    }
  },
  validations: {
    name: { required }
  }
};
</script>
